module.exports = __webpack_public_path__ + "img/271d6e6.png";